module.exports = __webpack_public_path__ + "static/media/img_gift.f1e30f85.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/PC/@1x/img_gift.png
// module id = 921
// module chunks = 0